"use client";

import { communitiesAdminGraphSchema } from "../../../../lib/types/schema/community/admin/communitiesAdminGraphSchema";
import { dateFormatYYYYMMDD } from "../../../../lib/utils/dates/dateFormatYYYYMMDD";
import type { UseRequestProps } from "../../../../request/hooks/useRequest";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyCommunitiesAdminGraph } from "./keyCommunitiesAdminGraph";

export type UseRequestCommunitiesAdminGraphProps = UseRequestProps & {
  endDate?: Date;
  id: number;
  startDate?: Date;
};

export const useRequestCommunitiesAdminGraph = ({
  endDate,
  id,
  startDate,
  ...props
}: UseRequestCommunitiesAdminGraphProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: communitiesAdminGraphSchema,
      urlBackendPath: `/communities/${id}/stats/completed-prayers-over-time?${startDate ? `start_date=${dateFormatYYYYMMDD({ date: startDate })}` : ""}${endDate ? `&end_date=${dateFormatYYYYMMDD({ date: endDate })}` : ""}`,
    },
    queryKey: keyCommunitiesAdminGraph({ endDate, id, startDate }),
  }),
});
